import { safeInit } from './includes/utils';
import { addEvent } from '../includes/_events';
import NavigationHistory from './includes/_navigationHistory.class';
import Tab from '@mozaic-ds/freemarker/js/modules/_tab.js';
import NavigationIndicator from '@mozaic-ds/freemarker/js/modules/_navigation-indicator.js';
import InstallmentPayments from './includes/installment-payments';
import { addToCart } from './includes/_atc';
import { initChangeStoreLinkWithStock } from './includes/_change-store';
import { initAccurateLeadTime } from './includes/_accurate-lead-time';
import setCheckedRadio from './includes/_setCheckedRadio';
import initQuantitySelector from './includes/_quantity-selector';
import { initDrawers } from '../common/init-drawers';
import { initModals } from '../common/init-modals';
import { initAccordions } from '../common/init-accordions';
import { sendFileDownload, trackingEvent } from '../common/tracking';
if (typeof __webpack_public_path__ !== 'undefined') {
  __webpack_public_path__ = '/static/';
}
export default class ProductDetail extends lm.Composant {
  constructor(id) {
    super(id);
    const productDetailSelector = '#product-detail';
    const self = this;
    const component = document.querySelector(productDetailSelector);
    if (!component) {
      return;
    }
    safeInit('scroll fix', () => {
      let followingHash = false;
      let anchorPageY = null;
      const stopFollowingHash = () => {
        followingHash = false;
        anchorPageY = null;
      };
      window.addEventListener('wheel', stopFollowingHash, {
        passive: true
      });
      window.addEventListener('touchmove', stopFollowingHash, {
        passive: true
      });
      const scrollToHashAnchor = () => {
        const hash = window.location.hash;
        if (!hash) {
          return;
        }
        const el = document.querySelector(hash);
        if (!el) {
          return;
        }
        anchorPageY = el.getBoundingClientRect().top + window.scrollY;
        el.scrollIntoView();
        followingHash = true;
      };
      window['lazy-loading-bus'].on('fragmentLoaded', () => {
        if (!followingHash) {
          return;
        }
        const hash = window.location.hash;
        if (!hash) {
          return;
        }
        const el = document.querySelector(hash);
        if (!el) {
          return;
        }
        const currentPageY = el.getBoundingClientRect().top + window.scrollY;
        if (currentPageY !== anchorPageY) {
          scrollToHashAnchor();
        }
      });
      window.addEventListener('hashchange', scrollToHashAnchor);
      scrollToHashAnchor();
    });

    // product part

    safeInit('accordion', () => {
      initAccordions(component, '.mc-accordion__item:not(.a-characteristicsButton)');
      this.seeMoreCharacteristics = component.querySelector('.js-openCharacteristicsDrawer');
      if (this.seeMoreCharacteristics) {
        this.seeMoreCharacteristics.addEventListener('click', () => {
          document.querySelector('#featuresAccordion').click();
        });
      }
      this.seePackaging = component.querySelector('.js-openPackagingDrawer');
      if (this.seePackaging) {
        this.seePackaging.addEventListener('click', () => {
          const chapter = document.querySelector('#packagingAccordion');
          if (chapter) {
            if (!chapter.classList.contains('js-generic-drawer')) {
              chapter.scrollIntoView();
            }
            chapter.click();
          }
        });
      }
    });
    safeInit('expand buttons', () => {
      const buttons = component.querySelectorAll('.js-expandButton');
      if (!buttons) {
        return;
      }
      for (const button of buttons) {
        const checkHeight = button.dataset.checkHeight;
        const idToExpand = button.getAttribute('aria-controls');
        if (!idToExpand) {
          button.remove();
          continue;
        }
        const elToExpand = component.querySelector('#' + idToExpand);
        if (!elToExpand) {
          button.remove();
          continue;
        }
        if (checkHeight === 'false' || elToExpand.scrollHeight > elToExpand.clientHeight) {
          button.addEventListener('click', e => {
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            elToExpand.classList.toggle('-isExpanded', !isExpanded);
            e.currentTarget.setAttribute('aria-expanded', (!isExpanded).toString());
          });
        } else {
          button.remove();
        }
      }
    });
    safeInit('carousel', () => {
      const mainCarousel = component.querySelector('#product-carousel');
      if (mainCarousel) {
        import(/* webpackChunkName: "productCarousel" */'./includes/_productCarousel.class').then(module => new module.default(mainCarousel)).catch(console.error);
      }
    });
    safeInit('catchphrases', () => {
      const indicators = component.querySelectorAll('.js-navigation-indicator');
      if (indicators) {
        for (const indicator of indicators) {
          new NavigationIndicator(indicator);
        }
      }
    });
    safeInit('media-zoom', () => {
      const mediaZooms = component.querySelectorAll('.w-component.w-carousel .o-zoom');
      if (mediaZooms) {
        import(/*webpackChunkName: "mediaZoom" */'./includes/mediaZoom/_mediaZoom.class').then(module => {
          for (const zoom of mediaZooms) {
            new module.default(zoom);
          }
        }).catch(console.error);
      }
    });
    safeInit('video', () => {
      const videos = component.querySelectorAll('.w-component.w-carousel .video-js');
      if (videos) {
        import(/* webpackChunkName: "video" */'./../legacy/_video.class').then(module => {
          new module.default('.w-component.w-carousel');
        }).catch(console.error);
      }
    });
    safeInit('packed-dimensions', () => {
      const boxes = component.querySelectorAll('.js-isometricBox');
      if (boxes) {
        import(/* webpackChunkName: "isometricBox" */'./includes/isometric-box.class').then(module => {
          for (const box of boxes) {
            new module.default(box);
          }
        }).catch(console.error);
      }
    });
    safeInit('generic drawers', () => {
      initDrawers(self);
    });
    safeInit('generic modals', () => {
      initModals(self);
    });
    safeInit('compo', () => {
      const compos = component.querySelectorAll('.js-compo');
      if (compos) {
        import(/* webpackChunkName: "compo" */'./includes/_compo.class').then(module => {
          for (const compo of compos) {
            new module.default(compo);
          }
        }).catch(console.error);
      }
    });
    safeInit('tabs', () => {
      const tabs = component.querySelectorAll('.js-generic-tab');
      if (tabs) {
        for (const tab of tabs) {
          new Tab(tab);
        }
      }
    });

    // offer part

    safeInit('main-add-to-cart', () => {
      addEvent(document, 'submit', e => addToCart(e.matchingTarget, e, 'main offer', this), '.js-add-to-cart-pdp-form', self);
    });
    safeInit('quotation', () => {
      addEvent(document, 'click', () => {
        const atcButton = document.querySelector('.js-add-to-cart-pdp-form .js-cart-add');
        if (atcButton) atcButton.click();
      }, '.js-quotation-button', self);
    });
    safeInit('other-offers', () => {
      addEvent(document, 'submit', e => {
        self._drawers['js-popin-show-offer-list']?.close();
        addToCart(e.matchingTarget, e, 'other offer', this);
      }, '.js-add-to-cart-form', self);
    });
    safeInit('change-store-with-stock', () => {
      initChangeStoreLinkWithStock('.js-delivery-store-link', 'NONE', self);
      initChangeStoreLinkWithStock('.js-choose-store-in_store', 'STOCK', self);
      initChangeStoreLinkWithStock('.js-choose-store-pickup', 'DELIVERY', self);
    });
    safeInit('accurate-lead-time', () => {
      initAccurateLeadTime(component);
    });
    safeInit('quantity-selector', () => {
      const forms = component.querySelectorAll('.js-quantity-selector-form');
      for (const form of forms) {
        initQuantitySelector(component, form);
      }
    });
    safeInit('installments', () => {
      const oneyButton = component.querySelector('.js-triggerOney');
      const paypalButton = component.querySelector('.js-triggerPaypal');
      if (oneyButton || paypalButton) {
        const installmentPayments = new InstallmentPayments();
        if (oneyButton) installmentPayments.installment0ney(oneyButton);
        if (paypalButton) installmentPayments.installmentPaypal(paypalButton);
      }
    });
    safeInit('installation-package', () => {
      const offerRadioButtons = component.querySelectorAll('input.js-offer-radio');
      setCheckedRadio(offerRadioButtons, 'li.js-offer-radio');
      const ctaTva = component.querySelector(`.js-reducedvat-drawer .js-layer-first-cta`);
      if (ctaTva) {
        ctaTva.addEventListener('click', () => {
          const {
            link
          } = ctaTva.dataset;
          if (link) {
            window.open(link, '_blank');
          }
        });
      }
    });
    safeInit('new-buy-box-installation-package', () => {
      const checkboxEl = component.querySelector('.js-toggle-installation-package');
      if (checkboxEl) {
        checkboxEl.addEventListener('change', e => {
          const pdpEl = component.closest('#product-detail');
          const installationEls = pdpEl.querySelectorAll('.js-buy-with-installation, .js-offer-product-only');
          for (const installationEl of installationEls) {
            installationEl.classList.toggle('mu-visually-hidden', e.checked);
            const haveAttributeAriaHidden = installationEl.getAttribute('aria-hidden');
            if (haveAttributeAriaHidden) {
              installationEl.setAttribute('aria-hidden', `${e.checked}`);
            }
          }
        });
      }
    });
    safeInit('tracking-events', () => {
      addEvent(document, 'click', el => {
        trackingEvent(el.matchingTarget);
      }, '[data-tracking-event]', self);
    });
    safeInit('last-seen-products', () => {
      const itemBuReference = document.querySelector('.js-product-ref') && document.querySelector('.js-product-ref').innerText;
      const itemIdentifier = document.querySelector('.js-item-identifier') && document.querySelector('.js-item-identifier').innerText;
      if (itemBuReference) {
        window.CustomerContext.eventBus.emit('CustomerContext.Update', [{
          key: 'LAST_SEEN_PRODUCTS',
          value: {
            itemBuReference: itemBuReference,
            itemIdentifier: itemIdentifier
          }
        }]);
      }
    });
  }
}
lm.DOMReady(() => {
  new ProductDetail('productdetail');
  new NavigationHistory();
});